<template>
  <tooltip
    :title="title"
    :placement="placement"
    class="help-tooltip"
  >
    <img
      src="../../img/check.svg"
      class="help-tooltip-img"
    >
  </tooltip>
</template>

<script>
  export default {
    name: 'help-tooltip',
    props: {
      title: {
        type: String,
      },
      placement: {
        type: String,
        default: 'bottom',
      },
    },
  }
</script>

<style lang="scss">
  .help-tooltip {
    margin-top: -5px;
    vertical-align: middle;
  }
  .help-tooltip-img {
    width: 16px;
    opacity: .4;
    &:hover {
      opacity: .8;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/help-tooltip.vue